export type TeamMember = {
  id: number;
  name: string;
  title: string;
  description: string;
  imageUrl: string;
};

type ApiTeamMember = {
  TeamMemberId: string | number;
  Name: string;
  Title: string;
  Description: string;
  ImageUrl?: string | null;
};

type ApiResponse<T> = T & { ok: boolean; message?: string };

async function parseJsonResponse<T>(response: Response): Promise<T> {
  const data = (await response.json().catch(() => ({}))) as ApiResponse<T>;
  if (!response.ok || data.ok === false) {
    throw new Error(data.message || "資料載入失敗，請稍後再試。");
  }
  return data as T;
}

function normalize(item: ApiTeamMember): TeamMember {
  return {
    id: Number(item.TeamMemberId),
    name: item.Name || "",
    title: item.Title || "",
    description: item.Description || "",
    imageUrl: item.ImageUrl || "",
  };
}

/** 供前台「關於我們」頁面的「專業團隊」區塊使用；若 API 尚未部署或失敗，回傳空陣列讓頁面略過該區塊。 */
export async function fetchPublicTeamMembers(): Promise<TeamMember[]> {
  try {
    const data = await fetch("/api/team-members", {
      credentials: "include",
      headers: { Accept: "application/json" },
    }).then((response) => parseJsonResponse<{ ok: boolean; TeamMembers: ApiTeamMember[] }>(response));
    return (data.TeamMembers || []).map(normalize);
  } catch {
    return [];
  }
}
